import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHero = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    let cancelled = false;

    const scrollToTarget = (attempt = 0) => {
      if (cancelled) {
        return;
      }

      const heroElement = document.querySelector('[data-hero="true"], [data-hero]');

      if (heroElement && typeof heroElement.scrollIntoView === "function") {
        heroElement.scrollIntoView({ behavior: attempt === 0 ? "smooth" : "auto", block: "start" });
        return;
      }

      if (attempt < 5) {
        window.requestAnimationFrame(() => scrollToTarget(attempt + 1));
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: attempt === 0 ? "smooth" : "auto" });
      }
    };

    const frame = window.requestAnimationFrame(() => scrollToTarget(0));

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
    };
  }, [location.pathname, location.search, location.hash, location.key]);

  return null;
};

export default ScrollToHero;
